export default __webpack_public_path__ + "static/media/Review text.dee142f9.svg";